module.exports = __webpack_public_path__ + "img/file-upload.a94b0726.svg";